  <table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false">
    <tr class="subwindow-title" cdkDragHandle>
      <th class="window-title-name">プロモーションマスタメンテナンス</th>
    </tr>
    <tr class="subwindow-body">
      <td colspan="2">
        <div class="contents-area" (dragstart)="onDragstartBody($event)">
          <div class ="column-list">
            <label class="list-input-title">番号</label>
            <div class="list-input-content content_number">
              <input type="text" id="lbl_PromotionNo" value="{{kymw4002Model.promotionNo}}" readonly>
            </div>

            <label class="list-input-title">プロモーション内容</label>
            <div class="list-input-content" style="width: 52rem;">
              <app-not-null-text-input id="tbx_PromotionInfo" #tbx_PromotionInfo [subid]="'tbx_PromotionInfo'"
                [fullOnly]="true" [maxChars]="50" [tabindex]="0" [displayCountField]="false"
                [(ngModel)]="kymw4002Model.promotionInfo" [forcedEnabledMode]="'true'"
                [restrict]="'[ -￮]'"></app-not-null-text-input>
            </div>

            <label class="list-input-title">マーク１</label>
            <div class="list-input-content">
              <app-mark-code-text-input id="tbx_MarkCode1" #tbx_MarkCode1
                [subid]="'tbx_MarkCode1'" [(ngModel)]="kymw4002Model.markCode1" [markNameField]="lbl_MarkName1" [initFocusItem]="tbx_PromotionInfo"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-mark-code-text-input>
              <label id="lbl_MarkName1"
                #lbl_MarkName1 hidden></label>
            </div>

            <label class="list-input-title">マーク２</label>
            <div class="list-input-content">
              <app-mark-code-text-input id="tbx_MarkCode2" #tbx_MarkCode2
                [subid]="'tbx_MarkCode2'" [(ngModel)]="kymw4002Model.markCode2" [markNameField]="lbl_MarkName2" [initFocusItem]="tbx_PromotionInfo"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-mark-code-text-input>
              <label id="lbl_MarkName2"
                #lbl_MarkName2 hidden></label>
            </div>

            <label class="list-input-title">マーク３</label>
            <div class="list-input-content">
              <app-mark-code-text-input id="tbx_MarkCode3" #tbx_MarkCode3
                [subid]="'tbx_MarkCode3'" [(ngModel)]="kymw4002Model.markCode3" [markNameField]="lbl_MarkName3" [initFocusItem]="tbx_PromotionInfo"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-mark-code-text-input>
              <label id="lbl_MarkName3"
                #lbl_MarkName3 hidden></label>
            </div>

            <label class="list-input-title">マーク４</label>
            <div class="list-input-content">
              <app-mark-code-text-input id="tbx_MarkCode4" #tbx_MarkCode4
                [subid]="'tbx_MarkCode4'" [(ngModel)]="kymw4002Model.markCode4" [markNameField]="lbl_MarkName4" [initFocusItem]="tbx_PromotionInfo"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-mark-code-text-input>
              <label id="lbl_MarkName4"
                #lbl_MarkName4 hidden></label>
            </div>

            <label class="list-input-title">マーク５</label>
            <div class="list-input-content">
              <app-mark-code-text-input id="tbx_MarkCode5" #tbx_MarkCode5
                [subid]="'tbx_MarkCode5'" [(ngModel)]="kymw4002Model.markCode5" [markNameField]="lbl_MarkName5" [initFocusItem]="tbx_PromotionInfo"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-mark-code-text-input>
              <label id="lbl_MarkName5"
                #lbl_MarkName5 hidden></label>
            </div>

            <label class="list-input-title">ダブル掲載</label>
            <div class="list-input-content">
              <app-checkbox-label id="chb_MultiPublishFlag" #chb_MultiPublishFlag
                [subid]="'chb_MultiPublishFlag'" [(ngModel)]="kymw4002Model.multiPublishFlag" [forcedEnabledMode]="'true'"
                [tabindex]="0"></app-checkbox-label>
            </div>
          </div>
        </div>
      </td>
    </tr>

    <tfoot cdkDragHandle>
      <tr>
        <td>
          <div class="footer-buttons">
            <button class="btn-tartiary warning" id="btn_Delete" #btn_Delete
              (click)="eventDeleteButton_CLICKHandler()" forcedEnabledMode="none" [tabindex]="0">削除</button>
            <button class="btn-primary" id="btn_Regist"
              (click)="eventUpdateButton_CLICKHandler()" forcedEnabledMode="true" [tabindex]="0">更新</button>
          </div>
          <div class="window-title-close">
            <button id="btn_Exit"
              (click)="onClickWindowClose()" forcedEnabledMode="true" [tabindex]="0"></button>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
